export default "__VITE_ASSET__DquQs_Ft__"